import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import { regions } from "../../data/specialTour";
import { ContentBand, Inner, KakaoButton, PageIntro, SectionHeader, SpecialTourLayout } from "./SpecialTourLayout";

export function RegionsPage() {
  return (
    <SpecialTourLayout>
      <PageIntro
        eyebrow="Regions"
        title="일본 골프는 계절을 맞추면 훨씬 편해집니다"
        body="홋카이도는 여름, 오사카·시코쿠·큐슈·오키나와는 가을부터 봄까지 강합니다. 지역마다 골프장 분위기와 여행 동선이 달라서 팀 성향에 맞춰 고릅니다."
        image="/special-tour-assets/shikoku-matsuyama-dogo.jpg"
      />
      <ContentBand className="bg-white">
        <Inner>
          <SectionHeader title="지역별 추천 시즌" body="골프장, 공항, 주변 관광지를 함께 보고 가장 무리 없는 동선을 잡습니다." />
          <div className="grid gap-6">
            {regions.map((region, index) => (
              <article
                id={region.slug}
                key={region.slug}
                className="grid scroll-mt-28 overflow-hidden rounded-lg border border-[#dce3d8] bg-[#fbfaf6] shadow-sm lg:grid-cols-[0.95fr_1.05fr]"
              >
                <img
                  src={region.image}
                  alt={region.imageAlt}
                  className={`h-80 w-full object-cover ${index % 2 === 1 ? "lg:order-2" : ""}`}
                />
                <div className="flex flex-col justify-center p-6 md:p-8">
                  <div className="text-sm font-900 text-[#d16339]">{region.season}</div>
                  <h2 className="mt-2 text-3xl font-900 text-[#15391f]">{region.name}</h2>
                  <p className="mt-4 text-base leading-8 text-[#596559]">{region.summary}</p>
                  <div className="mt-6 grid gap-4 md:grid-cols-2">
                    <div>
                      <h3 className="text-sm font-900 text-[#15391f]">대표 코스</h3>
                      <ul className="mt-3 grid gap-2 text-sm leading-6 text-[#596559]">
                        {region.courses.map((course) => (
                          <li key={course}>{course}</li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <h3 className="text-sm font-900 text-[#15391f]">함께 가기 좋은 곳</h3>
                      <ul className="mt-3 grid gap-2 text-sm leading-6 text-[#596559]">
                        {region.travel.map((place) => (
                          <li key={place}>{place}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="mt-7 flex flex-wrap gap-3">
                    <Link
                      to={`/itineraries#${region.slug}`}
                      className="inline-flex min-h-11 items-center justify-center gap-2 rounded-lg bg-[#15391f] px-4 text-sm font-900 text-white transition hover:bg-[#1e542e]"
                    >
                      일정 보기
                      <ArrowForwardIcon sx={{ fontSize: 18 }} />
                    </Link>
                    <KakaoButton label={`${region.name} 문의`} />
                  </div>
                </div>
              </article>
            ))}
          </div>
        </Inner>
      </ContentBand>
    </SpecialTourLayout>
  );
}
